import { get } from "svelte/store";

// Resolves the target workflow id of a `workflow_ref` step. Returns null for
// any other step type or when no workflow is selected on the step.
export function resolveWorkflowRefTarget(step) {
  if (step?.type !== "workflow_ref") return null;

  const workflowId = step.properties?.workflow_id?.id || step.properties?.workflow_id;
  return workflowId || null;
}

// Switches the designer to the given workflow id, if it still exists in the
// file tree.
export function navigateToWorkflow(filetreeStore, workflowId) {
  if (!workflowId) return;

  const flatList = get(filetreeStore.itemsAsFlatList);
  const targetNode = flatList.find((item) => item.id === workflowId);

  if (targetNode) {
    filetreeStore.selectNode(targetNode);
  }
}
